/* import placesApi from "../../api/places" */
import utilsApi from "../../api/utils"

// general state for the eCommerce
const state = {
  places: [],
  fetched: false,
  error: false,
  dataShape: [],
  extraInfo: {},
}

const getters = {
  places: state => state.places,
  places_fetched: state => state.fetched,
  placesError: state => state.error,
  places_dataShape: state => state.dataShape,
  places_extraInfo: state => state.extraInfo,
}

const actions = {
  async DELETE_places({ commit }, place) {
    let apiResponse = await utilsApi.deleteObject("places", place)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PLACES_SETTING", apiResponse)
    } else {
      commit("PLACES_ERROR")
    }
  },
  async CREATE_places({ commit }, place) {
    let apiResponse = await utilsApi.createObject("places", place)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PLACES_SETTING", apiResponse)
    } else {
      commit("PLACES_ERROR")
    }
  },
  async SAVE_places({ commit }, place) {
    let apiResponse = await utilsApi.saveObject("places", place)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PLACES_SETTING", apiResponse)
      return true
    } else {
      commit("PLACES_ERROR")
      return false
    }
  },
  async FETCH_places({ commit }) {
    let apiResponse = await utilsApi.getObjects("places")
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PLACES_SETTING", apiResponse)
      return true
    } else {
      commit("PLACES_ERROR")
      return false
    }
  },
  CLEAN_places({ commit }) {
    commit("PLACES_CLEAN")
    return true
  },
}
const mutations = {
  PLACES_SETTING: (state, { places, dataShape, extraInfo }) => {
    console.log(state)
    state.places = places
    state.dataShape = dataShape
    state.extraInfo = extraInfo
    state.fetched = true
    state.error = false
  },
  PLACES_ERROR: state => {
    state.places = null
    state.fetched = true
    state.error = false
    state.dataShape = []
  },
  PLACES_CLEAN: state => {
    state.places = []
    state.fetched = false
    state.error = false
    state.dataShape = []
    state.extraInfo = {}
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
